<script lang="ts">
  interface Props {
    size?: number;
  }

  let { size = 14 }: Props = $props();
</script>

<svg
  class="now-glyph"
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  aria-hidden="true"
>
  <circle cx="8" cy="8.25" r="5.35" stroke="currentColor" stroke-width="1.5" />
  <path
    d="M8 5.4V8.25l2.05 1.25"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path d="M6.1 2.15h3.8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
  <path d="M8 2.15v1.35" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
</svg>

<style>
  .now-glyph {
    display: block;
  }
</style>
